// Australian spacing: landlines "<area code> 1234 5678", mobiles "0400 000 000", 1300/1800 "1300 123 456"
export function formatPhone(v) {
  if (!v) return v;
  const s = String(v).trim();
  if (/[a-z]/i.test(s)) return s;
  const digits = s.replace(/\D/g, "");
  const compact = s.replace(/[\s()-]/g, "");
  if (/^04\d{8}$/.test(compact)) return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
  if (/^\+614\d{8}$/.test(compact)) return `+61 ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
  if (/^1[38]00\d{6}$/.test(compact)) return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
  if (digits.length < 8) return s;
  let count = 0;
  let idx = 0;
  for (let i = s.length - 1; i >= 0; i--) {
    if (/\d/.test(s[i]) && ++count === 8) { idx = i; break; }
  }
  let prefix = s.slice(0, idx).replace(/[\s-]+$/, "").replace(/\s+/g, " ").trim();
  if (/^0011\d/.test(prefix)) prefix = `0011 ${prefix.slice(4)}`;
  const last = digits.slice(-8);
  return `${prefix ? `${prefix} ` : ""}${last.slice(0, 4)} ${last.slice(4)}`;
}
